import { createSlice } from "@reduxjs/toolkit";
import axios from "../app/axios";

const degreeSlice = createSlice({
  name: "degreeSlice",
  initialState: {
    degree: [],
    degreeCourses: {},
    courseGroups: {},
    errorMessage: undefined,
    dataFetchingStatus: false,
    errorStatusCode: undefined,
  },
  reducers: {
    setDegree: (state, action) => {
      state.degree = action.payload;
    },
    setDegreeCourse: (state, action) => {
      state.degreeCourses = action.payload;
    },
    setCourseGroups: (state, action) => {
      state.courseGroups = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    setErrorStatusCode: (state, action) => {
      state.errorStatusCode = action.payload;
    },
    setDataFetchingStatus: (state, action) => {
      state.dataFetchingStatus = action.payload;
    },
  },
});

const {
  setDegree,
  setDegreeCourse,
  setCourseGroups,
  setErrorMessage,
  setErrorStatusCode,
  setDataFetchingStatus,
} = degreeSlice.actions;

export const getDegree = (studentId) => (dispatch) => {
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  dispatch(setDataFetchingStatus(true));
  axios
    .get(`/students/degree/${studentId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setDegree(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getDegreeCourse = (data) => (dispatch) => {
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  dispatch(setDataFetchingStatus(true));
  axios
    .post("/students/degreecourses", data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      if (response.status === 404) {
        dispatch(setErrorMessage(response.data.error));
      } else {
        dispatch(setDegreeCourse(response.data));
      }
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getCourseGroups = (data) => (dispatch) => {
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  dispatch(setDataFetchingStatus(true));
  axios
    .post("/students/coursegroups", data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      if (response.status === 404) {
        dispatch(setErrorMessage(response.data.error));
      } else {
        dispatch(setCourseGroups(response.data));
      }
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const clearErrorStatusCode = () => (dispatch) => {
  dispatch(setErrorStatusCode(undefined));
};

export const clearErrorMessage = () => (dispatch) => {
  dispatch(setErrorMessage(undefined));
};

export const clearData = () => (dispatch) => {
  dispatch(setDegree([]));
  dispatch(setDegreeCourse([]));
  dispatch(setCourseGroups([]));
};

export default degreeSlice.reducer;
